import type { FilterParam } from '../../../types/baseExplorerConfig';

/**
 * #693 — single source of truth for mapping Weather Data Explorer filters onto
 * request URL params. BOTH the list service adapter and the export capture use
 * this, so the export can never silently drop a constraint the table applies
 * (previously the export copy had drifted, omitting stationId, errors, ffmcMin
 * and the whole numeric-filter block).
 */
const NUMERIC_FIELDS = new Set([
    'temperature', 'relativeHumidity', 'windSpeed', 'windDirection', 'precipitation',
    'fireWeatherIndex', 'ffmc', 'dmc', 'dc', 'isi', 'bui',
]);

export function appendWeatherFilters(apiParams: URLSearchParams, filters: FilterParam[] | undefined): void {
    if (!filters) return;
    for (const f of filters) {
        if (f.value == null || f.value === '') continue;

        if (NUMERIC_FIELDS.has(f.field)) {
            const nv = f.value as { operator: string; value?: number; value2?: number };
            if (!nv?.operator) continue;
            if (nv.operator === 'null') { apiParams.append(`${f.field}_null`, 'true'); continue; }
            if (nv.operator === 'notNull') { apiParams.append(`${f.field}_notNull`, 'true'); continue; }
            if (nv.operator === 'between') {
                if (nv.value != null) apiParams.append(`${f.field}_gte`, String(nv.value));
                if (nv.value2 != null) apiParams.append(`${f.field}_lte`, String(nv.value2));
            } else if (nv.value != null) {
                apiParams.append(`${f.field}_${nv.operator}`, String(nv.value));
            }
            continue;
        }

        switch (f.field) {
            case 'region': apiParams.append('region', f.value as string); break;
            case 'dataSource': apiParams.append('dataSource', f.value as string); break;
            case 'status': apiParams.append('status', f.value as string); break;
            case 'dateRange':
                if (f.operator === 'gte' && typeof f.value === 'string') apiParams.append('startDate', f.value);
                else if (f.operator === 'lte' && typeof f.value === 'string') apiParams.append('endDate', f.value);
                break;
            case 'hour': apiParams.append('hour', String(f.value)); break;
            case 'showInvalid': if (f.value === 'yes') apiParams.append('includeInvalid', 'true'); break;
            case 'ffmcMin': apiParams.append('ffmcMin', f.value as string); break;
            case 'stationId': apiParams.append('stationId', f.value as string); break;
            case 'stationName': apiParams.append('stationName', f.value as string); break;
            case 'errors': apiParams.append('errors', f.value as string); break;
        }
    }
}
